import React, { useState, useEffect } from "react";
import Map from "./OpenLayers/Map/Map";
import { TileLayer, VectorLayer } from "./OpenLayers/Layers/index";
import { Style, Icon, Text } from "ol/style";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import { osm, vector } from "./OpenLayers/Source";
import { fromLonLat, get } from "ol/proj";
import { Controls, FullScreenControl } from "./OpenLayers/Controls";
import { Stroke } from "ol/style";
import { Fill } from "ol/style";
import { Card } from "primereact/card";

type Coordinates = {
  data: any;
};
function addMarkers(lonLatArray: any) {
  var iconStyle = new Style({
    image: new Icon({
      anchorXUnits: "fraction",
      anchorYUnits: "pixels",
      src: "https://www.laengengrad-breitengrad.de/public/img/marker-icon-2x.png",
    }),
  });

  let features = lonLatArray.map((item: any) => {
    let feature;
    if(item["cordinates"][0] === "0.0000" && item["cordinates"][1] === "0.0000" ){
      feature = new Feature({
        geometry: new Point(fromLonLat([7.0575, 51.4625]))
      });
    }
    else {
      feature = new Feature({
        geometry: new Point(fromLonLat(item["cordinates"])),
      });
    }
    // feature.setStyle(iconStyle);
    feature.setStyle(
      new Style({
        image: new Icon({
          src: "https://cdn2.iconfinder.com/data/icons/social-media-and-payment/64/-47-32.png",
          // scale: 0.1,
        }),
        text: new Text({
          text: item["station"],
          font: "bold 12px sans-serif",
          fill: new Fill({
            color: "black",
          }),
          stroke: new Stroke({
            color: "white",
            width: 4,
          }),
          offsetY: -15,
        }),
      })
    );
    return feature;
  });
  return features;
}

const MapWrapper = (props: Coordinates) => {
  const noVal = ["0.0000", "0.0000"];
  const [center, setCenter] = useState<any>(() => {
    if(props.data.length === 0){
      return ["7.0582", "51.4623"];
    }
    else if (
      props.data[0]["cordinates"].filter((element: any) =>
        noVal.includes(element)
      )
    ) {
      return ["7.0582", "51.4623"];
    } else {
      return props.data[0]["cordinates"];
    }
  });
  const [zoom, setZoom] = useState(10);

  const [features, setFeatures] = useState(
    addMarkers(props.data ? props.data : ["7.0582", "51.4623"])
  );

  return (
      // <Card
      //     style={{ margin: "0.5em auto", overflowX: "auto", padding: '0px !important' }}
      //     className="event-container"
      // >
        <div className='p-card mt-3'>
          <Map center={fromLonLat(center)} zoom={zoom}>
            <TileLayer source={osm()} zIndex={0} />
            <VectorLayer source={vector({ features })} style />
            <Controls>
              <FullScreenControl />
            </Controls>
          </Map>
        </div>
      // </Card>

  );
};

export default MapWrapper;
